import React from 'react';
import { Layout as AntdLayout } from 'antd';

import { FixedBackground } from '@atoms';
import { useIsAuthenticated } from '@hooks';

import Sider from '../Sider';
import Header from '../Header';

const { Content } = AntdLayout;
// To-do correct Content spacing after Eliot finish with mobile version design

const Layout = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <AntdLayout style={{ minHeight: '100vh', overflowX: 'hidden' }}>
      <FixedBackground />
      <Header />
      <AntdLayout>
        {isAuthenticated && <Sider />}
        <Content style={{ padding: '0 50px 50px' }}>{children}</Content>
      </AntdLayout>
    </AntdLayout>
  );
};

export default Layout;
